export const arrayToObject = arr => {
  if (!arr) {
    return;
  }
  return Object.assign({}, ...arr.map(item => ({[item]: item})));
};



// WEBPACK FOOTER //
// ./helpers/array.helper.js